import { render, staticRenderFns } from "./sliders.vue?vue&type=template&id=2d1e5947&scoped=true&"
import script from "./sliders.vue?vue&type=script&lang=js&"
export * from "./sliders.vue?vue&type=script&lang=js&"
import style0 from "./sliders.vue?vue&type=style&index=0&id=2d1e5947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1e5947",
  null
  
)

export default component.exports